import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { buildUrl } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/client/errors/RequiredPayloadFieldIsNotProvided';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/debugging/actorGeographic`;

interface GetRulesDebuggingActorGeographic {
  claimId?: string;
  onlyMatchingRules?: boolean;
}

interface Value {
  inputResults: Record<string, string>[];
}

interface GetRulesDebuggingActorGeographicResponse {
  value: Value;
}

async function getRulesDebuggingActorGeographic({
  claimId,
  onlyMatchingRules,
}: GetRulesDebuggingActorGeographic): Promise<Value> {
  const functionName = 'getRulesDebuggingActorGeographic';

  if (!claimId) {
    throw new RequiredPayloadFieldIsNotProvided(claimId, `${functionName}`);
  }

  const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId);

  const response = await apiCall<GetRulesDebuggingActorGeographicResponse>(
    buildUrl(url, { onlyMatchingRules }),
    {
      method: SUPPORTED_METHODS.GET,
    },
  );

  return response.value;
}

export default getRulesDebuggingActorGeographic;
